
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarElectronicRangeAndBearingProposal as ObiRadarElectronicRangeAndBearingProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-electronic-range-and-bearing-proposal.js';
 
 
 

 
 export const ObiRadarElectronicRangeAndBearingProposal = createComponent({
   react: React,
   tagName: 'obi-radar-electronic-range-and-bearing-proposal',
   elementClass: ObiRadarElectronicRangeAndBearingProposalElement,
   events: {
     
   }
  });
 
 